import { useCallback, useState } from 'react'

export const useModal = (defaultVisible = false) => {
  const [visible, setVisible] = useState(defaultVisible)
  const showModal = useCallback(() => setVisible(true), [])
  const hideModal = useCallback(() => setVisible(false), [])

  return [visible, showModal, hideModal] as [boolean, () => void, () => void]
}
